import React from 'react';
import './Home.css';

export const Home = () => {
  return (
    <div className='home'></div>
  )
}
